(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/constants/assets/javascripts/promise-status.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/constants/assets/javascripts/promise-status.js');
"use strict";


const PromiseStatus = {
  Fulfilled: 'fulfilled',
  Rejected: 'rejected'
};
const toExport = {
  PromiseStatus
};
if (svs.isServer) {
  module.exports = toExport;
} else {
  setGlobal('svs.components.marketplaceCompetition.constants.promiseStatus', toExport);
}

 })(window);